import { service } from '.';

export default {
  getAll: (data) => service.post('/organizations/search', data),
  getOne: (id) => service.get(`/organizations/${id}`),
  create: (data) => service.post(`/organizations`, data),
  update: (id, data) => service.put(`/organizations/${id}`, data),
  delete: (id) => service.delete(`/organizations/${id}`),
};
